import React from "react";

/**
 * A titled group of related fields inside an editor section.
 *
 * One level below the section heading and above the fields, so a section can
 * carry two distinct topics — rent figures and amenity labels, say — without
 * stacking another card border around each of them.
 */
export default function ListingFieldGroup({ title, description, children }) {
  return (
    <div>
      <h5 className="m-0 text-[13px] font-semibold uppercase tracking-wide text-muted-foreground">
        {title}
      </h5>
      {description ? (
        <p className="m-0 mb-4 mt-1 text-[13px] text-muted-foreground">{description}</p>
      ) : (
        <div className="mb-4" />
      )}
      <div className="grid gap-5">{children}</div>
    </div>
  );
}
